module.exports = {"event_date_at_x_oclock":"at :date","show_map":"Show map"};